import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NotificationService } from "../../../shared/services/notification.service";
import {
  passwordPolicyValidator,
  passwordsMatchValidator,
} from "../../../shared/validators";
import { ResetPasswordModel } from "../../auth-models";
import { AuthService } from "../../auth.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  showerror: boolean;
  errormessage: any;
  baseUrl: string;
  hidePassword = true;
  hidePassword2 = true;
  // True when arriving from a first-time account-setup invite (?setup=true),
  // so the page reads "Set Your Password" instead of "Reset Password".
  isAccountSetup = false;

  /*
  // Moved to ngOnInit to avoid initialization errors.
  resetPasswordForm = this.fb.group({
    password: [null, { validators: [Validators.required, Validators.maxLength(16), Validators.minLength(8), ascendPasswordValidator] }],
    confirmedPassword: [null, { validators: [Validators.required] }],
  },
    { updateOn: 'blur', validators: passwordsMatchValidator }
  );
  */
  resetPasswordForm: any;

  get password() {
    return this.resetPasswordForm.get("password");
  }

  get confirmedPassword() {
    return this.resetPasswordForm.get("confirmedPassword");
  }

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private notifService: NotificationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isAccountSetup =
      this.route.snapshot.queryParamMap.get("setup") === "true";

    this.resetPasswordForm = this.fb.group(
      {
        password: [
          null,
          {
            validators: [
              Validators.required,
              Validators.maxLength(24),
              Validators.minLength(12),
              passwordPolicyValidator(),
            ],
          },
        ],
        confirmedPassword: [null, { validators: [Validators.required] }],
      },
      { updateOn: "blur", validators: passwordsMatchValidator }
    );
  }

  onSubmit() {
    this.resetPasswordForm.markAllAsTouched();
    this.resetPasswordForm.updateValueAndValidity();

    if (this.resetPasswordForm.valid) {
      const model = <ResetPasswordModel>this.resetPasswordForm.value;
      model.id = this.route.snapshot.queryParamMap.get("id");
      model.token = this.route.snapshot.queryParamMap.get("token");
      this.authService.resetPassword(model).subscribe(
        () => {
          this.notifService.success("Password was reset!");
        },
        (error) => {
          this.notifService.error("Password reset failed.");
        }
      );
    }
  }

  getErrorMessage() {
    return this.password.hasError("required")
      ? "You must enter a value"
      : this.password.hasError("minlength")
      ? "Password must be at least 12 characters"
      : this.password.hasError("maxlength")
      ? "Password must be no greater than 24 characters"
      : this.password.hasError("ascend-password")
      ? "Password must contain at least one uppercase letter, at least one lowercase letter, and at least one number"
      : "";
  }
}
